import {
  AsyncAutocompleteSelect,
  Option,
} from "@/components/select/AsyncAutocompleteSelect";
import {
  getOptionsHandler,
  loadOptionsHandler,
} from "@/pages/requests/cash/schema/handler-functions";
import { AppColors } from "@/styles/colors";
import { Box, Card, Field, Text } from "@chakra-ui/react";
import { Dispatch, SetStateAction, useRef } from "react";
import { useFormContext } from "react-hook-form";

interface Props {
  setLoadingPersons: Dispatch<SetStateAction<boolean>>;
  loadingPersons: boolean;
}

export const AssociateAccountCard = ({
  setLoadingPersons,
  loadingPersons,
}: Props) => {
  const getOptions = async (
    inputValue: string,
  ): Promise<
    {
      label: string;
      value: string;
      tipoCuenta: string;
      idTipoCuenta: number;
    }[]
  > => {
    return getOptionsHandler({
      inputValue,
    });
  };

  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const loadOptions = (inputValue: string): Promise<Option[]> => {
    return loadOptionsHandler({
      getOptions,
      inputValue,
      setLoadingPersons,
      timeoutRef,
    });
  };

  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Card.Root maxW="full" marginTop="30px" borderRadius="8px">
      <Card.Body
        paddingX="48px"
        paddingY="30px"
        borderRadius="8px"
        border={`1px solid ${AppColors.WHITE_BORDER_1}`}
      >
        <Field.Root invalid={!!errors?.cuenta?.message} gap="12px">
          <Field.Label>
            {" "}
            <Text fontSize="16px">Cuenta</Text>
          </Field.Label>

          <Box minWidth="300px">
            <AsyncAutocompleteSelect
              control={control}
              loadOptions={loadOptions}
              name="cuenta"
              placeholder="Buscar..."
              isLoading={loadingPersons}
            />
          </Box>

          <Field.ErrorText>{String(errors?.cuenta?.message)}</Field.ErrorText>
        </Field.Root>
      </Card.Body>
    </Card.Root>
  );
};
